import axios from "axios";

const myAxios = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

let unauthorizedCallback = null;
let navigateFunction = null;

export const setUnauthorizedCallback = (callback) => {
  unauthorizedCallback = callback;
};

export const setNavigateFunction = (navigate) => {
  navigateFunction = navigate;
};

// Add request interceptor for setting auth token
myAxios.interceptors.request.use((config) => {
  // Login can return jwtToken: null, in which case token is the JWT
  const authToken = localStorage.getItem("jwtToken") || localStorage.getItem("token");
  config.headers.Authorization = authToken ? "Bearer " + authToken : null;

  // Add impersonation token if present
  const impersonationToken = localStorage.getItem("impersonation_token");
  if (impersonationToken) {
    config.headers["X-Impersonation-Token"] = impersonationToken;
  }
  config.headers["X-Region"] = "LATAM";
  return config;
});

myAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    const isChatCreateToken =
      error.config && error.config.url.includes("/business/chat/create-token");

    // Handle 401 Unauthorized (token expired/invalid)
    if (error.response && error.response.status === 401) {
      // Clear tokens and user data
      localStorage.removeItem("token");
      localStorage.removeItem("jwtToken");
      localStorage.removeItem("userData");
      localStorage.removeItem("impersonation_token");
      localStorage.removeItem("original_admin_token");
      
      // Call unauthorized callback if set (should trigger logout)
      if (unauthorizedCallback) {
        unauthorizedCallback();
      } else if (navigateFunction) {
        navigateFunction("/login");
      } else {
        // Fallback: reload page to trigger RouteGuard logout
        window.location.href = "/login";
      }
    }
    
    // Handle 403 Forbidden (permission denied)
    if (error.response && error.response.status === 403) {
      if (!isChatCreateToken) {
        if (unauthorizedCallback) {
          unauthorizedCallback();
        } else if (navigateFunction) {
          // navigateFunction("/business/billing");
        } else {
          console.error("Unauthorized");
        }
      }
    }
    return Promise.reject(error);
  }
);

export default myAxios;
